import React from "react";
import { useQuery } from "@apollo/client";
import { useLocation } from "react-router";

import * as qs from "query-string";

import { LoadingOverlay } from "components";

import { GET_REPORT_URL } from "api/Reports/queries";
import { GetReportUrl, GetReportUrlVariables } from "api/Reports/types/GetReportUrl";

import styles from "./styles.module.scss";

const SisenseSSO: React.FC = () => {
  const location = useLocation();

  const { data } = useQuery<GetReportUrl, GetReportUrlVariables>(GET_REPORT_URL, {
    variables: {
      embedUrl: decodeURIComponent(`${qs.parse(location.search).return_to}${location.hash}`),
    },
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-only",
  });

  if (data && data.sisenseEmbedUrl && data.sisenseEmbedUrl.url) {
    window.location.href = data.sisenseEmbedUrl.url;
  }

  return <LoadingOverlay customStyles={styles.loadingOverlay} />;
};

export default SisenseSSO;
